import { systemFontStack } from "../utils/AdaptiveUiThemeStyle";
/**
 * Temekart Rogaland client theme
 */
export const tkrog = {
    name: "tkrog",
    fontStack: systemFontStack,
    fontWeight: 400,
    headingFontWeight: 400,
    headingTextColor: "#252A35",
    linkTextColor: "hsl(125, 38%, 40%)",
    defaultTextColor: "#252A35",
    primary: "#56B15E",
    primaryContrast: "#fff",
    secondary: "#9DC873",
    secondaryContrast: "#252A35",
    tertiary: "#9bd6f0",
    tertiaryContrast: "#252A35",
    success: "#56B15E",
    successContrast: "#ffffff",
    warning: "#FDD06F",
    warningContrast: "#252A35",
    danger: "#FB8500",
    dangerContrast: "#252A35",
    dark: "#252A35",
    medium: "#e9e9e9",
    light: "#f6f6f6",
    inputBackground: "#fdfdfd",
    inputBorderColor: "#313745",
    inputTextColor: "#252A35",
    inputShadowBlur: 0,
    inputShadowOffset: "0 0",
};
